import { render } from "./DrinkCard.vue?vue&type=template&id=a6393f28&scoped=true"
import script from "./DrinkCard.vue?vue&type=script&lang=js"
export * from "./DrinkCard.vue?vue&type=script&lang=js"

import "./DrinkCard.vue?vue&type=style&index=0&id=a6393f28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a6393f28"

export default script